module.exports = __webpack_public_path__ + "img/拉手锁 (2).f48b5849.png";